/**
 * Typed search params for the `/timesheets` route. The selected week lives in the URL so it is
 * deep-linkable AND compile-checked (the estimates/jobs/dispatch `searchParams` pattern). TanStack
 * Router validates the raw URL params through `validateTimesheetsSearch` on every navigation.
 *
 * `?week=YYYY-MM-DD` selects which week the grid + the totals reflect (the week-nav prev/next links
 * carry this). The coarse endpoint (22-13) normalises any in-week date to the Monday week-start; the
 * SPA only carries the value.
 */

const ISO_DATE = /^\d{4}-\d{2}-\d{2}$/;

export interface TimesheetsSearch {
  week?: string;
}

/** Coerce a raw URL value into an ISO date string, else undefined. */
function asIsoDate(value: unknown): string | undefined {
  return typeof value === 'string' && ISO_DATE.test(value) ? value : undefined;
}

/**
 * TanStack Router `validateSearch` for the timesheets route. Keeps `week` only when it is a valid ISO
 * date so the canonical URL stays clean (`/timesheets` vs `/timesheets?week=2026-06-01`).
 */
export function validateTimesheetsSearch(raw: Record<string, unknown>): TimesheetsSearch {
  const search: TimesheetsSearch = {};
  const week = asIsoDate(raw.week);
  if (week) search.week = week;
  return search;
}
